import { render, staticRenderFns } from "./CoreTechnology.vue?vue&type=template&id=13e38d5c&scoped=true&"
import script from "./CoreTechnology.vue?vue&type=script&lang=js&"
export * from "./CoreTechnology.vue?vue&type=script&lang=js&"
import style0 from "./CoreTechnology.vue?vue&type=style&index=0&id=13e38d5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e38d5c",
  null
  
)

export default component.exports